// extracted by mini-css-extract-plugin
module.exports = {"s6y9bk2":"s6y9bk2","top":"top","bottom":"bottom","smallscreen":"smallscreen"};